import { render } from "./CustomerDetailsModal.vue?vue&type=template&id=46e02bb6&scoped=true&ts=true"
import script from "./CustomerDetailsModal.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailsModal.vue?vue&type=script&lang=ts"

import "./CustomerDetailsModal.vue?vue&type=style&index=0&id=46e02bb6&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e02bb6"]])

export default __exports__